// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
Vue.config.productionTip = false

//适配方案 引入 淘宝方案 flexble
import './assets/flexible.js'

// var echarts = require('echarts');
// 引入 ECharts 主模块
var echarts = require('echarts/lib/echarts');
// 引入柱状图
require('echarts/lib/chart/bar');
require('echarts/lib/chart/line');
require('echarts/lib/chart/pie');
// 引入提示框和标题组件
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
require('echarts/lib/component/markPoint');
require('echarts/lib/component/legend');
require('echarts/lib/component/legendScroll');
import {
	Form,
	FormItem,
	Input,
	InputNumber,
	Button,
	Select,
	Dropdown,
	DropdownMenu,
	DropdownItem,
	MessageBox,
	Message,
	Option,
} from 'element-ui';
Vue.component(Button.name, Button);
Vue.use(Dropdown).use(DropdownMenu).use(DropdownItem).use(Form).use(FormItem).use(Input).use(InputNumber).use(Option).use(Select)

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
import store from './store'
//vue全局注入echarts
Vue.prototype.$echarts = echarts
Vue.prototype.$message = Message
Vue.prototype.msgSuccess = function(msg) {
  this.$message({
    showClose: true,
    message: msg,
    type: "success"
  });
}

Vue.prototype.msgError = function(msg) {
  this.$message({
    showClose: true,
    message: msg,
    type: "error"
  });
}

Vue.prototype.msgInfo = function(msg) {
  this.$message.info(msg);
}

import axios from 'axios'
const instance = axios.create({

})
Vue.prototype.$axios = instance;
// 自定义全局组件引入
import top_item from './components/top_item'

import center from './components/center'


import left from './components/left'
import right from './components/right'


// import left from './kanban1/left'
// import right from './kanban1/right'

// import left from './views/saikedu/left'
// import right from './views/saikedu/right'

Vue.component('topItem', top_item)
Vue.component('left', left)
Vue.component('center', center)
Vue.component('right', right)

// dataV 插件按需引入
import {
	loading,
	borderBox13,
	decoration5,
	scrollBoard,
	borderBox12
} from '@jiaminghi/data-view'

Vue.use(loading)
Vue.use(decoration5)
Vue.use(borderBox13)
Vue.use(borderBox12)
Vue.use(scrollBoard)

// 解决样式被覆盖的问题
import './assets/css/base.css'

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js